import { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { getListDetailLocation, getListReturnLocation } from "utils/helpers/tableUrlSync";

/**
 * Navigate to a list item detail page while preserving list table query params for back navigation.
 */
function useListDetailNavigation(pathName) {
  const history = useHistory();
  const location = useLocation();

  const navigateToDetail = useCallback(
    (id, { view = false } = {}) => {
      if (!id) {
        return;
      }
      history.push(getListDetailLocation(pathName, id, location.search, { view }));
    },
    [history, pathName, location.search]
  );

  const listReturnTo = useMemo(() => getListReturnLocation(pathName, location), [pathName, location]);

  return { navigateToDetail, listReturnTo };
}

export default useListDetailNavigation;
